import React, { useEffect } from "react";
import ChatMessageDecrypting from "./ChatMessageDecrypting";
import ChatMessageDecryptFailed from "./ChatMessageDecryptFailed";
import { AppConstant } from "const";

const DecryptMessageView = ({ created, isMine = false, isDecryptFailed, setIsDecryptFailed = () => {} }) => {
  useEffect(() => {
    const checkDecryptStatus = () => {
      const currentTime = new Date().getTime();
      // Todo pj47 set time to one hour for test
      const isFailed = currentTime - created > AppConstant.ONE_HOUR;
      setIsDecryptFailed(isFailed);
    };

    checkDecryptStatus();

    const intervalId = setInterval(checkDecryptStatus, 1000);

    return () => {
      setIsDecryptFailed(false);
      clearInterval(intervalId);
    };
  }, [created]);

  return isDecryptFailed ? <ChatMessageDecryptFailed /> : <ChatMessageDecrypting isMine={isMine} />;
};

export default DecryptMessageView;
